var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","text-center":"","py-5":""}},[_c('span',{staticClass:"head"},[_vm._v("Find Nearby Beekeepers")])]),_c('v-flex',{attrs:{"id":"googlemap"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }